import { getEnvDataFromContext, getUserDataFromContext } from '@/common/helpers/requestHelpers';
import { Env, User } from '@/common/types';
import { TAG_MANAGER_ENVIRONMENT } from '@/constants/tagManager';
import { ProductRoadmap2026Head } from '@/containers/ProductRoadmapPage/ProductRoadmap2026Head';
import { ProductRoadmapPage } from '@/containers/ProductRoadmapPage';
import { TagManager } from '@eventbrite/webapp-data';
import { GetServerSideProps, NextPage } from 'next';

interface ServerData {
  env: Env;
  user: User;
}

export const getServerSideProps: GetServerSideProps<ServerData> = async (context) => {
  const env = getEnvDataFromContext(context);
  const user = getUserDataFromContext(context);

  return {
    props: {
      env,
      user,
    },
  };
};

const ProductRoadmap2026Page: NextPage<ServerData> = (props) => {
  return (
    <>
      <ProductRoadmap2026Head />
      <ProductRoadmapPage env={props.env} />
      <TagManager
        publicUserId={props.user.userId}
        stage={props.env.stage}
        environment={TAG_MANAGER_ENVIRONMENT}
      />
    </>
  );
};

export default ProductRoadmap2026Page;
